export default __webpack_public_path__ + "e88049f0c4bab557b39eccc0c2478fdc.png";